import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { polarisProjectArchivedIdeasEntryPoint } from '@jira/spa-apps__polaris-project-archived-ideas/src/polarisProjectArchivedIdeasEntryPoint.entrypoint.tsx';
import { polarisProjectLayout } from '@jira/platform__layouts-polaris-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { polarisProjectArchivedIdeasRoute } from '@jira/router-routes__polaris-routes/src/polarisProjectArchivedIdeasRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const polarisProjectArchivedIdeasPageEntryPoint = createPageEntryPoint({
	main: polarisProjectArchivedIdeasEntryPoint,
});

export const polarisProjectArchivedIdeasRouteEntry: Route = createEntry(
	polarisProjectArchivedIdeasRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'polaris',
		ufoName: 'jpd.archived-ideas',
		layout: polarisProjectLayout,
		canTransitionIn: () => true,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			incidentExperimentTraitResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
		],

		entryPoint: () =>
			fg('jpd_new_archived_page')
				? polarisProjectArchivedIdeasPageEntryPoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
